import { FC, useEffect, useState } from "react";

import Script from "next/script";

interface CustomGTMScriptProps {
  shouldInjectGTM: boolean;
  googleTagManagerId: string | null | undefined;
}

const getExcludeGTMFromNextData = (): boolean => {
  if (typeof document === "undefined") {
    return false;
  }
  try {
    const el = document.getElementById("__NEXT_DATA__");
    const data = el ? (JSON.parse(el.textContent ?? "{}") as { props?: { pageProps?: { excludeGTM?: boolean } } }) : {};
    return Boolean(data?.props?.pageProps?.excludeGTM);
  } catch {
    return false;
  }
};

export const CustomGTMScript: FC<CustomGTMScriptProps> = ({ shouldInjectGTM, googleTagManagerId }) => {
  const [excludeGTM, setExcludeGTM] = useState(false);

  useEffect(() => {
    setExcludeGTM(getExcludeGTMFromNextData());
  }, []);

  if (!shouldInjectGTM || !googleTagManagerId || excludeGTM) {
    return null;
  }

  const scriptId = `custom-gtm-${googleTagManagerId.replace(/[^a-zA-Z0-9-]/g, "-")}`;

  return (
    <>
      <Script
        id={`${scriptId}-datalayer`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleTagManagerId}');
          `,
        }}
      />
      <Script
        id={`${scriptId}-js`}
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`}
      />
    </>
  );
};
